/* eslint-env browser */
/* global YT */
import { fire, findOne, on } from 'domassist';
let isReady = false;

function onReady(instance, late = false) {
  if (isReady) {
    return;
  }

  isReady = true;
  const embed = instance.embed;
  const container = instance.player.getContainer();
  const caption = findOne('[data-plyr=captions]', container);
  let captionsEnabled = false;
  let initialCaptions = false;
  const onStateChange = e => {
    if (e.data === YT.PlayerState.PLAYING) {
      // eslint-disable-next-line no-use-before-define
      initHandler();
    }
  };

  const initHandler = () => {
    if (initialCaptions) {
      return;
    }

    setTimeout(() => caption.click(), 300);
    initialCaptions = true;
    embed.removeEventListener('onReady', initHandler);
    embed.removeEventListener('onStateChange', onStateChange);
  };

  const onApiChange = () => {
    try {
      if (!captionsEnabled) {
        return;
      }

      const languages = embed.getOption('captions', 'translationLanguages');

      if (languages && Array.isArray(languages)) {
        const language = languages.filter(e => e.languageCode === 'en')[0];

        if (language) {
          embed.setOption('captions', 'track', language);
        }
      }
    } catch (e) {
      // Error silently
    }
  };

  if (caption) {
    caption.style.display = 'block';

    on(caption, 'click', () => {
      try {
        captionsEnabled = caption.getAttribute('aria-pressed') === 'true';

        if (captionsEnabled) {
          embed.loadModule('captions');

          // Dirty check to see if captions were loaded
          setTimeout(() => {
            const track = embed.getOption('captions', 'track');

            if (track && !Object.keys(track).length) {
              onApiChange();
            }
          }, 500);
        } else {
          embed.unloadModule('captions');
        }
      } catch (e) {
        // Error silently
      }
    });

    embed.addEventListener('onApiChange', onApiChange);
    embed.addEventListener('onReady', initHandler);
    embed.addEventListener('onStateChange', onStateChange);

    if (late) {
      // Ready already happened for some inexplicable reason
      caption.click();
    }
  }
}

export default function(instance) {
  const embed = instance.embed;
  const container = instance.player.getContainer();

  instance.player.on('ready', () => onReady(instance));

  embed.addEventListener('onStateChange', e => {
    switch (e.data) {
      case YT.PlayerState.PLAYING:
        onReady(instance, true);
        fire(container, 'plyr:playing', { bubbles: true });
        break;
      case YT.PlayerState.ENDED:
        fire(container, 'plyr:ended', { bubbles: true });
        break;
      default:
    }
  });
}
